/* eslint-disable no-shadow */
/* eslint-disable import/prefer-default-export */
export enum UserTypes {
  PRODUCER = 'PRODUCER',
  CREW_MEMBER = 'CREW_MEMBER',
  NULL = 'NULL',
}

export enum ProjectStateTypes {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export enum UserRoles {
  LINE_PRODUCER = 'LINE_PRODUCER',
  PRODUCTION_COORDINATOR = 'PRODUCTION_COORDINATOR',
  OFFICE_PA = 'OFFICE_PA',
}
